import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_EXPORT_ORDER_HISTORY_DETAIL:
      return { ...action.exportOrderHistoryDetail };
    default:
      return state;
  }
};
